export default __webpack_public_path__ + "static/media/marlborough-college-malaysia.847916ae.png";